// src/hooks/useUnlockTokens.js
import { useEffect, useRef, useState, useCallback } from "react";
import { getToken, redirectToLogin } from "../utils/auth";

export default function useUnlockTokens({ refreshMs = 60_000 } = {}) {
  const [count, setCount] = useState(null);
  const [source, setSource] = useState(null);
  const [error, setError] = useState(null);
  const abortRef = useRef(null);

  const fetchTokens = useCallback(async () => {
    try {
      abortRef.current?.abort();
      const ac = new AbortController();
      abortRef.current = ac;

      setError(null);
      const token = getToken();
      const res = await fetch(
        "https://whiteintel.io/api/regular/app/v2/user/get_unlock_tokens.php",
        {
          method: "GET",
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          signal: ac.signal,
        }
      );
               if ([401, 419, 440].includes(res.status)) {
      redirectToLogin();
      // throw to stop callers from continuing
      throw new Error(`AUTH_REDIRECT_${res.status}`);
    }

      if (!res.ok) throw new Error(`HTTP ${res.status}`);
      const json = await res.json();
      setCount(typeof json.unlock_tokens === "number" ? json.unlock_tokens : null);
      setSource(json.source || null);
    } catch (e) {
      if (e.name !== "AbortError") setError(e.message || "Failed to fetch");
    }
  }, []);

  useEffect(() => {
    fetchTokens();
    if (!refreshMs) return;
    const id = setInterval(fetchTokens, refreshMs);
    return () => clearInterval(id);
  }, [fetchTokens, refreshMs]);

  return { count, source, error, refresh: fetchTokens };
}
